import defaultTheme from './default';

export default {
  ...defaultTheme,
  backgroundColor: '#262626',
  playerBackground: '#000000',
  menuBackground: '#111111',
  overlayColor: 'rgba(0, 0, 0,  0.5)',
  defaultColor: '#ffffff',
  epgBorderColor: 'rgba(255, 255, 255, 0.75)',
  epgTimeColor: 'rgba(255, 255, 255, 0.5)',
  mainTextColor: '#cccccc',
  secondaryTextColor: '#9F9F9F',
  activeColor: '#E8B30D',
  imagePlaceholder: '#191919',
  iconDefaultColor: '#9F9F9F',
  submenuActiveColor: '#444444',
  buttonBorderColor: 'rgba(159, 159, 159, 0.5)',
  backgroundLoaderColor: 'rgba(38, 38, 38, 0.9)',
  backgroundNetworkLoaderColor: 'rgba(38, 38, 38, 0.97)',
  backgroundSettingsColor: 'rgba(38, 38, 38, 0.75)',
  playerButtonBg: 'rgba(0, 0, 0, 0.5)',
  playerClockBg: 'rgba(25, 25, 25, 0.25)',
  invalidInput: '#ff3333',
  catchUpLabelColor: '#1da253',
  onAirLabelColor: '#FF000D',
  programTextColor: '#666666',
  devider: '#4B4B4B',
};
